export default "__VITE_ASSET__3574c917__"